'use client';

import { ShoppingBag, ArrowRight } from '@phosphor-icons/react';
import Link from 'next/link';

export function ActionsCTA() {
  return (
    <section className="py-16 sm:py-24">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <div className="relative rounded-3xl overflow-hidden animate-fade-up">
          {/* Background */}
          <div className="absolute inset-0 bg-gradient-to-br from-[var(--primary)] via-[var(--violet-600)] to-[var(--violet-700)]" />

          {/* Decorative circles */}
          <div className="absolute -top-20 -right-20 w-60 h-60 rounded-full bg-white/10" />
          <div className="absolute -bottom-16 -left-16 w-48 h-48 rounded-full bg-white/8" />

          {/* Content */}
          <div className="relative z-10 px-8 py-14 sm:px-14 sm:py-16 text-center">
            <div className="w-16 h-16 rounded-full bg-white/20 border-2 border-white/30 flex items-center justify-center mx-auto mb-6">
              <ShoppingBag weight="fill" className="w-8 h-8 text-[var(--text-on-primary)]" />
            </div>

            <h2 className="text-3xl sm:text-4xl font-heading font-black text-[var(--text-on-primary)] mb-4 tracking-tight">
              Попробуйте наши акции!
            </h2>

            <p className="text-[var(--text-on-primary)]/90 text-lg max-w-lg mx-auto mb-8 leading-relaxed">
              Закажите сейчас и воспользуйтесь всеми нашими выгодными предложениями
            </p>

            <Link
              href="/"
              className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-white text-[var(--primary)] font-bold text-base shadow-xl shadow-black/10 transition-all duration-200 hover:shadow-2xl hover:scale-[1.02] active:scale-[0.98]"
            >
              Перейти к заказу
              <ArrowRight weight="bold" className="w-5 h-5" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
